import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { UploadService } from '../../../services/upload/upload.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { UploadDocumentComponent } from '../../../components/upload-document/upload-document.component';
import { DmsFile } from '../../../modal/upload/model/upload.model';
@Component({
  selector: 'app-need-genration',
  standalone: false,
  templateUrl: './need-genration.component.html',
  styleUrl: './need-genration.component.scss',
})
export class NeedGenrationComponent implements OnInit, AfterViewInit {
  @ViewChild(UploadDocumentComponent) uploadDocumentComp!: UploadDocumentComponent;
  @Input() id: any;
  @Input() getUrl: any;
  @Input() postUrl: any;
  @ViewChild('fileUpload') fileUpload!: FileUpload;
  @ViewChild('draftSotrUpload') draftSotrUpload!: FileUpload;
  @ViewChild('briefPdUpload') briefPdUpload!: FileUpload;
  @ViewChild('pptUpload') pptUpload!: FileUpload;
  @ViewChild('supportDocsUpload') supportDocsUpload!: FileUpload;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  @Output() stepCompleted = new EventEmitter<void>();
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  baseUrl: string = environment.APIUrl;
  payload: ProposalPayload;
  @Input() step: any;
  @Input() schemeType: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() view_sign: EventEmitter<any> = new EventEmitter();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Output() submitProposal: EventEmitter<any> = new EventEmitter();
  @Input() stepDetails: any;
  @Input() type: any;
  // challengeForm: FormGroup;
  equipment: Equipment[] = [];
  system: System[] = [];
  filteredEquipment: Equipment[] = [];
  filteredSystem: System[] = [];
  ship: Ship[] = [];
  filteredShip: Ship[] = [];
  uploadedFiles: any[] = [];
  needGenId: any;
  needGenData: NeedGenerationResponse;
  @Input() isEditable: boolean = false;
  userID: any;
  pptFile: any;
  briefFromPD: any;
  allDmsFiles: any = [];
  // upload doc progress
  uploadProgress: number = 0; // ✅ define it here
  tenderModes = [
    { label: 'Open Tender', value: 'Open Tender' },
    { label: 'Single Tender', value: 'Single Tender' },
    { label: 'Limited Tender', value: 'Limited Tender' },
  ];

  // Add New Equipment/System dialog
  showAddEquipmentDialog = false;
  showAddSystemDialog = false;
  newEquipmentName = '';
  newSystemName = '';


  constructor(
    private fb: FormBuilder,
    private config: PrimeNGConfig,
    private messageService: MessageService,
    private api: ApiService,
    private uploadService: UploadService,
    private route: ActivatedRoute
  ) {
    this.proposalForm = this.fb.group({
      nomenclature: ['', Validators.required],
      platform: [''],
      tenderMode: [''],
      equipment: [''],
      system: [''],
      qtyReqd: ['', Validators.required],
      qtyPrototype: ['', Validators.required],
      qtyBulk: ['', Validators.required],
      estimatedDevelopmentCost: [''],
      development_prototype: [''],
      exchequer:[''],
      estimatedCost: [''],
      estimatedUnitCost: [''],
      llp: [''],
      lpyear: [null],
      poev: [''],
      consignee: [''],

      // Technical details
      technologyInsertion: [''],
      justificationText: [''],
      exportPotential: [''],
      approvalOfSOTRs: [''],
      dualUseTechnology: [null],
      brief_description: [''],
      requirement_met: [''],
      technical_details: [''],

      // Make scheme – Basic / Justification
      indigenously_designed: [''],
      capability_infrastructure: [''],
      ltpp: [''],

      // Make scheme – Detailed (editors)
      lead_development: [''],
      indigenise_equipment: [''],
      rfi_indigenous: [''],
      collaboration_envisaged: [''],
      drdo_psu: [''],
      technical_specifications: [''],
      operationalRequirements: [''],
      drawings_manuals: [''],
      sample_indigenisation: [''],
      annual_Acquisition: [''],
      trials_environments: [''],
      photograph_item: [''],
      export_potential: [''],
      project_similar: [''],
      approval_apso: [''],
      nodal_officer_details: [''],

      // Draft Project Report
      critical_technology: [''],
      drdo_infrastructure: [''],
      trial_infrastructure: [''],

      // Make II only
      revenue_idex: [''],
    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role;
  }

  ngOnInit(): void {
    console.log('need-genration & schemetype', this.step, this.schemeType);
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName,
      };
    });
    this.apiCall();
    this.getProposalData();
  }
  ngAfterViewInit() {
    setTimeout(() => {
      if (this.isEditable || this.stepDetails?.can_edit) {
        this.isEditorDisabled = false;
        this.proposalForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.proposalForm.disable();
      }
      // this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false;
    setTimeout(() => {
      this.init = this.getTinyInit();
      this.editorReady = true;
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled,
    };
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }
  onDualUseTechnologyChange(value: boolean) {
    this.proposalForm.patchValue({ dualUseTechnology: value });
  }
  dmsFiles: any[] = [];
  getProposalData() {
    let url;
    if (this.type == 'approval') {
      if (this.schemeType == 'rev') {
        url = `/revenue/approval/need-generation/`
      } else {
        url = `/make1/approval/need-generation/`
      }

    } else {
      if (this.schemeType == 'rev') {
        url = `/revenue/approval/need-generation/`
      } else {
        url = `/make1/need-generation/`
      }

    }
    this.api
      .getAPI(url +
        `?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`
      )
      .subscribe((res: any) => {
        console.log('need revenue data', res);

        // Handle different response structures
        let responseData = null;

        // Check if res is an array with data
        if (Array.isArray(res) && res.length > 0) {
          responseData = res[0];
        }
        // Check if res has need_generation property
        else if (res && res.need_generation) {
          responseData = res.need_generation;
        }
        // Check if res itself is the data object (not in array)
        else if (res && typeof res === 'object' && !Array.isArray(res) && res.id) {
          responseData = res;
        }

        // If no data found and step is approved, try approval endpoint as fallback (for Make schemes)
        if (!responseData && !this.type && this.schemeType !== 'rev' &&
          (this.stepDetails?.step_status == 'approved' || this.stepDetails?.step_status == 'recommended')) {
          const approvalUrl = `/make1/approval/need-generation/?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
          this.api.getAPI(approvalUrl).subscribe((approvalRes: any) => {
            console.log('approval endpoint fallback data', approvalRes);
            let approvalData = null;
            if (Array.isArray(approvalRes) && approvalRes.length > 0) {
              approvalData = approvalRes[0];
            } else if (approvalRes && approvalRes.need_generation) {
              approvalData = approvalRes.need_generation;
            } else if (approvalRes && typeof approvalRes === 'object' && !Array.isArray(approvalRes) && approvalRes.id) {
              approvalData = approvalRes;
            }

            if (approvalData) {
              this.needGenData = approvalData;
              this.dmsFiles = approvalRes?.approval_data?.[0]?.dms_files || [];
              if (this.needGenData?.dms_files?.length > 0) {
                this.allDmsFiles = this.needGenData.dms_files;
              } else {
                this.allDmsFiles = this.dmsFiles;
              }
              this.patchFormValues(approvalData);
              this.needGenId = approvalData.id;
            }
          });
          return;
        }

        this.needGenData = responseData;
        console.log('>>>>>dataNeed', this.needGenData);

        // Handle DMS files
        this.dmsFiles = res?.approval_data?.[0]?.dms_files || [];
        if (this.needGenData?.dms_files?.length > 0) {
          this.allDmsFiles = this.needGenData.dms_files;
        } else {
          this.allDmsFiles = this.dmsFiles;
        }

        // Patch form values if data exists
        if (responseData) {
          this.patchFormValues(responseData);
          this.needGenId = responseData.id;
        }

        sessionStorage.setItem('needStepID', this.id);
      });
  }

  onDocumentUpload(data: any) {
    console.log('>>>>data from upload', data);
    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', data.name);
    formData.append('description', data.description);
    formData.append('file', data.file);

    // ✅ Use your service method here
    this.uploadService.uploadneedGenData(formData).subscribe({
      next: (res: any) => {
        console.log('>>>>>>res need upload data', res);

      },

      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    });

  }

  onDocumentEdited(updatedDoc: any) {
    console.log('✏️ Edited document from child:', updatedDoc);

    const formData = new FormData();
    formData.append('proposal_step', this.id);
    formData.append('name', updatedDoc.name);
    formData.append('type_doc', updatedDoc.type_document);
    formData.append('description', updatedDoc.description);

    // Only append file if it's a new file (File object)
    if (updatedDoc.file instanceof File) {
      formData.append('file', updatedDoc.file);
    }

    // ✅ Update API call
    this.uploadService.updateUploadNeedGenData(updatedDoc.id, formData).subscribe({
      next: (response: any) => {
        console.log('✅ Document updated successfully:', response);

        // ✅ Replace the updated record instead of pushing new
        const index = this.allDmsFiles.findIndex((d) => d.id === updatedDoc.id);
        if (index !== -1) {
          // Update the existing record
          this.allDmsFiles[index] = { ...this.allDmsFiles[index], ...updatedDoc };
        }
      },
      error: (err) => {
        console.error('❌ Update failed:', err);
      },
    });
  }

  onDocumentDeleted(docId: number) {
    console.log('🗑️ Deleted document ID from child:', docId);

    this.uploadService.deleteUploadNeedGenData(docId).subscribe({
      next: (res: any) => {
        console.log('delete uploadData', res);
      },
      error: (err) => {
        console.error('❌ Upload failed:', err);
      }
    })

    // Optionally call delete API
  }
  apiCall() {
    this.api.getAPI('/master/system-master/').subscribe((res: any) => {
      this.system = res.data;
      this.filteredSystem = res.data;
    });
    this.api.getAPI('/master/equipment-master/').subscribe((res: any) => {
      this.equipment = res.data;
      this.filteredEquipment = res.data;
    });
  }
  draftSotr: File;
  onFileSelect(event: any, uploadType: 'draftSotr' | 'supportingDocs' | 'ppt' | 'briefFromPD') {
    if (uploadType === 'draftSotr') {
      // Only one Draft SOTR allowed, replace previous
      this.draftSotr = event.files[0];
    } else if (uploadType === 'ppt') {
      // Only one PPT allowed, replace previous
      this.pptFile = event.files[0];
    } else if (uploadType === 'briefFromPD') {
      // Only one Brief allowed, replace previous
      this.briefFromPD = event.files[0];
    } else {
      for (let file of event.files) {
        this.uploadedFiles.push(file);
      }
    }

    this.messageService.add({
      severity: 'success',
      summary: 'Success',
      detail: 'File(s) attached successfully',
    });
  }

  searchSheames(event: any, type: String) {
    if (type == 'eqp') {
      let query = event.query.toLowerCase();
      this.filteredEquipment = this.equipment.filter((equipment) =>
        equipment.name.toLowerCase().includes(query)
      );
    } else if (type == 'sys') {
      let query = event.query.toLowerCase();
      this.filteredSystem = this.system.filter((system) =>
        system.name.toLowerCase().includes(query)
      );
    } else if (type == 'ship') {
      let query = event.query.toLowerCase();
      this.filteredShip = this.ship.filter((ship) =>
        ship.name.toLowerCase().includes(query)
      );
    }
  }

  patchFormValues(data: any) {
    if (!data) return;
    const lppYearFromAPI = data.lpp_year; // e.g., "2026-01-01" or 2026

    let lppYearDate: Date | null = null;

    if (lppYearFromAPI) {
      const yearMatch = lppYearFromAPI.toString().match(/\d{4}/); // extract 4-digit year
      if (yearMatch) {
        const year = Number(yearMatch[0]);
        lppYearDate = new Date(year, 0, 1); // Jan 1st of that year
      }
    }


    this.proposalForm.patchValue({
      // API field mappings based on your submit function
      nomenclature: data?.nomenclature,
      platform: data?.platform,
      tenderMode: data?.mode_tendor,
      qtyReqd: data?.qty_req || data?.total_qty_req,
      qtyPrototype: data?.prototype_qty,
      qtyBulk: data?.bulk_qty,
      estimatedDevelopmentCost: data?.development_cost,
      estimatedCost: data?.amount,
      development_prototype: data?.development_prototype,
      exchequer: data?.exchequer,

      estimatedUnitCost: data?.unit_cost,
      justificationText: data?.justification,
      exportPotential: data?.proposed_item || data?.export_potential,
      equipment: data?.equipment?.id || data?.equipment,
      system: data?.system?.id || data?.system,
      vendor: data?.vendor,
      consignee: data?.consignee,

      // Rich Text Editor fields
      introduction: data?.introduction,
      proposal: data?.proposal_desc,
      summary: data?.summary,
      financialImplication: data?.financial_implication,
      justification: data?.justification,

      // Basic / Brief
      brief_description: data?.brief_description,
      technical_details: data?.technical_details,
      requirement_met: data?.requirement_met,
      dualUseTechnology: data?.dual_technology === true || data?.dual_technology === 'true',

      // Additional fields
      technologyInsertion: data?.technical_details,
      approvalOfSOTRs: data?.formulation_sotr || data?.approval_apso,
      approval_apso: data?.approval_apso,
      llp: data?.lpp_cost,
      lpyear: data?.lppYearDate,
      poev: data?.poev,

      // Make scheme – Justification section
      indigenously_designed: data?.indigenously_designed,
      capability_infrastructure: data?.capability_infrastructure,
      ltpp: data?.ltpp,

      // Make scheme – Detailed (editors)
      lead_development: data?.lead_development,
      indigenise_equipment: data?.indigenise_equipment,
      rfi_indigenous: data?.rfi_indigenous,
      collaboration_envisaged: data?.collaboration_envisaged,
      drdo_psu: data?.drdo_psu,
      technical_specifications: data?.technical_specifications,
      operationalRequirements: data?.operational_requirement,
      drawings_manuals: data?.drawings_manuals,
      sample_indigenisation: data?.sample_indigenisation,
      annual_Acquisition: data?.annual_Acquisition,
      trials_environments: data?.trials_environments,
      photograph_item: data?.photograph_item,
      export_potential: data?.export_potential,
      project_similar: data?.project_similar,
      nodal_officer_details: data?.nodal_officer_details,

      // Draft Project Report
      critical_technology: data?.critical_technology,
      drdo_infrastructure: data?.drdo_infrastructure,
      trial_infrastructure: data?.trial_infrastructure,

      // Make II only
      revenue_idex: data?.revenue_idex,
    });
    console.log('Form values after patching:', this.proposalForm.value.qtyPrototype, data?.prototype_qty);
  }

  onSubmit() {
    const formData = new FormData();
    // formData.append('proposal_step', this.id);
    if (
      this.schemeType != 'makeI' &&
      this.schemeType != 'makeII' &&
      this.schemeType != 'makeIII'
    ) {
      formData.append('equipment_id', this.proposalForm.value.equipment);
      formData.append('system_id', this.proposalForm.value.system);
      formData.append('qty_req', this.proposalForm.value.qtyReqd);
      formData.append('proposed_item', this.proposalForm.value.exportPotential);
      formData.append('platform', this.proposalForm.value.platform);
      formData.append('mode_tendor', this.proposalForm.value.tenderMode);
      if (this.uploadedFiles.length > 0) {
        this.uploadedFiles.forEach((file, index) => {
          formData.append(`uploaded_files`, file);
        });
      }
    } else {
      formData.append('total_qty_req', this.proposalForm.value.qtyReqd);
      formData.append('export_potential', this.proposalForm.value.exportPotential);
      if (this.uploadedFiles.length > 0) {
        this.uploadedFiles.forEach((file, index) => {
          formData.append(`needmake_files`, file);
        });
      }
    }
    formData.append('consignee', this.proposalForm.value.consignee);
    formData.append('nomenclature', this.proposalForm.value.nomenclature);

    formData.append('prototype_qty', this.proposalForm.value.qtyPrototype);
    formData.append('bulk_qty', this.proposalForm.value.qtyBulk);
    formData.append(
      'development_cost',
      this.proposalForm.value.estimatedDevelopmentCost
    );
    formData.append('unit_cost', this.proposalForm.value.estimatedUnitCost);
    formData.append('justification', this.proposalForm.value.justificationText);
    formData.append('exchequer', this.proposalForm.value.exchequer);
    

    formData.append(
      'formulation_sotr',
      this.proposalForm.value.approvalOfSOTRs
    );
    formData.append('lpp_cost', this.proposalForm.value.llp);
    formData.append('lpp_year', this.proposalForm.value.lpyear);
    formData.append('poev', this.proposalForm.value.poev);
    formData.append(
      'technical_details',
      this.proposalForm.value.technologyInsertion
    );

    if (this.draftSotr) {
      formData.append('draft_sotr', this.draftSotr);
    }


    if (this.schemeType !== 'rev') {
      if (this.pptFile) {
        formData.append('ppt_document', this.pptFile);
      }
      if (this.briefFromPD) {
        formData.append('brief_document', this.briefFromPD);
      }
    }


    if (this.needGenId) {
      this.api
        .putAPI(this.postUrl + this.needGenId + '/', formData)
        .subscribe((res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Form submitted successfully',
          });
          this.getProposalData();
          this.draftSotrUpload?.clear();
          this.fileUpload?.clear();
          this.supportDocsUpload?.clear();
          this.pptUpload?.clear();
          this.briefPdUpload?.clear()
        });
    } else {
      this.api.postAPI(this.postUrl, formData).subscribe({
        next: (response: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Form submitted successfully',
          });
          // this.proposalForm.disable();
          this.getProposalData();
          this.draftSotrUpload?.clear();
          this.fileUpload?.clear();
          this.supportDocsUpload?.clear();
          this.pptUpload?.clear();
          this.briefPdUpload?.clear()
          // this.stepCompleted.emit();
        },
      });
    }
  }

  generatePDF() {
    const data: any[] = [
      { key: 'Proposal Name', value: this.payload.proposal_name },
      {
        key: 'Nomenclature',
        value: this.proposalForm.get('nomenclature')?.value,
      },
      {
        key: 'Quantity Required',
        value: this.proposalForm.get('qtyReqd')?.value,
      },
      {
        key: 'Quantity Prototype',
        value: this.proposalForm.get('qtyPrototype')?.value,
      },
      {
        key: 'Quantity Bulk (MoQ)',
        value: this.proposalForm.get('qtyBulk')?.value,
      },

      {
        key: 'Estimated Unit Cost',
        value: this.proposalForm.get('estimatedUnitCost')?.value,
      },
      { key: 'LLP Cost', value: this.proposalForm.get('llp')?.value },

      {
        key: 'Brief Description / Technical Details',
        value: this.proposalForm.get('technologyInsertion')?.value,
      },
      {
        key: 'Formulation & approval of SOTRs',
        value: this.proposalForm.get('approvalOfSOTRs')?.value,
      },
      {
        key: `Justification for progressing the case under ${this.categoryLabel} category`,
        value: this.proposalForm.get('justificationText')?.value,
      },
      {
        key: 'Any export potential of the proposed item',
        value: this.proposalForm.get('exportPotential')?.value,
      },
      // { key: "Details of stakeholders discussions at SHQ Level", value: this.proposalForm.get('stakeholderDiscussions')?.value },
    ];

    // Conditionally include these fields if schemeType is not 'makeI'
    if (
      this.schemeType !== 'makeI' &&
      this.schemeType !== 'makeII' &&
      this.schemeType !== 'makeIII'
    ) {
      const equipmentId = this.proposalForm.get('equipment')?.value;
      const systemId = this.proposalForm.get('system')?.value;

      const equipmentName =
        this.filteredEquipment.find((e) => e.id === equipmentId)?.name || '';
      const systemName =
        this.filteredSystem.find((s) => s.id === systemId)?.name || '';
      data.splice(2, 0, { key: 'Equipment', value: equipmentName });
      data.splice(3, 0, { key: 'System', value: systemName });
      data.splice(9, 0, {
        key: 'POEV Cost',
        value: this.proposalForm.get('poev')?.value,
      });
      data.splice(10, 0, {
        key: 'Consignee',
        value: this.proposalForm.get('consignee')?.value,
      });
      data.splice(7, 0, {
        key: 'Estimated Total Cost',
        value: this.proposalForm.get('estimatedDevelopmentCost')?.value,
      },)
    } else {
      data.splice(7, 0, {
        key: 'Estimated Development Cost',
        value: this.proposalForm.get('estimatedDevelopmentCost')?.value,
      },)
      data.splice(10, 0, { key: 'LLP Year', value: this.proposalForm.get('lpyear')?.value },)
    }

    const payload = {
      url: '/revenue/need/version-control/',
      data,
    };

    this.generatePDFEmitter.emit(payload);
  }

  editForm() {
    this.proposalForm.enable();
    this.isEditorDisabled = false;
    this.messageService.add({
      severity: 'info',
      summary: 'Info',
      detail: 'Form is now editable',
    });
  }

  getFileName(url: string): string {
    const fileName = url.split('/').pop() || '';
    return fileName.length > 50 ? fileName.substring(0, 50) + '...' : fileName;
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'];
    if (allowedKeys.includes(event.key)) return;

    const isNumber = /^[0-9]$/.test(event.key);
    if (!isNumber) {
      event.preventDefault();
    }
  }
  viewSign() {
    this.view_sign.emit();
  }
  get categoryLabel(): string {
    switch (this.schemeType) {
      case 'rev': return 'Revenue';
      case 'makeI': return 'Make I';
      case 'makeII': return 'Make II';
      case 'makeIII': return 'Make III';
      default: return '';
    }
  }
  expandedSections = {
    basicInfo: false,
    equipment: false,
    quantity: false,
    cost: false,
    detailedInfo: false,
    requirementIndigenise: false,
    uploads: false,
    justification: false,
    reports: false,
    manufacture: false,
  };

  toggleSection(section: string) {
    this.expandedSections[section] = !this.expandedSections[section];
  }
  APSOApproved() {
    console.log('APSOApproved');
  }

  addNewEquipment() {
    const name = this.newEquipmentName?.trim();
    if (!name) return;
    this.api.postAPI('/master/equipment-master/', { name }).subscribe({
      next: (res: any) => {
        const newItem = res.data || res;
        this.equipment.push(newItem);
        this.filteredEquipment = [...this.equipment];
        this.proposalForm.get('equipment')?.setValue(newItem.id);
        this.showAddEquipmentDialog = false;
        this.newEquipmentName = '';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Equipment added successfully.' });
      },
      error: (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to add equipment.' });
      }
    });
  }

  addNewSystem() {
    const name = this.newSystemName?.trim();
    if (!name) return;
    this.api.postAPI('/master/system-master/', { name }).subscribe({
      next: (res: any) => {
        const newItem = res.data || res;
        this.system.push(newItem);
        this.filteredSystem = [...this.system];
        this.proposalForm.get('system')?.setValue(newItem.id);
        this.showAddSystemDialog = false;
        this.newSystemName = '';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'System added successfully.' });
      },
      error: (err: any) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message || 'Failed to add system.' });
      }
    });
  }


  isMakeScheme(): boolean {
  if (Array.isArray(this.schemeType)) {
    return this.schemeType.includes('makeI') ||
           this.schemeType.includes('makeII') ||
           this.schemeType.includes('makeIII');
  }

  return ['makeI','makeII','makeIII'].includes(this.schemeType);
}

isMakeIorII(): boolean {
  if (Array.isArray(this.schemeType)) {
    return this.schemeType.includes('makeI') || this.schemeType.includes('makeII');
  }
  return this.schemeType === 'makeI' || this.schemeType === 'makeII';
}

}
interface ProposalPayload {
  proposal_id: number;
  proposal_name: string;
  // mode?:string
}

interface Equipment {
  id: number;
  name: string;
}

interface System {
  id: number;
  name: string;
}

interface Ship {
  id: number;
  name: string;
}

interface NeedGenerationResponse {
  id: number;
  status?: string;
  nomenclature: string;
  qty_req: number;
  prototype_qty: number;
  bulk_qty: number;
  development_cost: number;
  unit_cost: number;
  justification: string;
  proposed_item: string;
  stakeholder_discussions: string;
  formulation_sotr: string;
  lpp_cost: number;
  poev: number;
  consignee: string;
  equipment: Equipment | number;
  system: System | number;
  draft_sotr?: any;
  need_files?: any;
  ppt_document?: any;
  brief_document?: any;
  needmake_files?: any;
  dms_files?: DmsFile[];
}
// export interface DmsFile {
//   id: number;
//   name: string;
//   description: string;
//   file: string;
//   is_approved: boolean;
//   document_flag: boolean;
//   uploaded_at: string;
//   file_status: number;
//   proposal_step: number;
// }